import 'babel-polyfill'
import 'iview/dist/styles/iview.css'
import '@/static/lib/css/iconfont/iconfont.css'
import '@/static/lib/css/normallize/normallize.css'
import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App'
import {i18n} from 'plugins/i18n'
import inject from 'plugins/inject'
import decorate from 'plugins/decorate'
import sentry from 'plugins/sentry'
import iView from 'iview'
// 全局实例化注入
Vue.use(inject)
Vue.use(iView)
Vue.use(decorate)
Vue.use(sentry)
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js